<script setup lang="ts">
import RadioButton from './RadioButton/RadioButton.vue'
import type { IProps, IEmits } from './RadioButtonController.types'

withDefaults(defineProps<IProps>(), { variant: 'horizontal' })

const model = defineModel<string | number | boolean>()
const emits = defineEmits<IEmits>()

const handleUpdate = (value: string | number | boolean) => {
  emits('update', value)
}
</script>

<template>
  <div
    :class="[
      'radioButtonController',
      `radioButtonController--${variant}`
    ]"
  >
    <RadioButton
      v-for="(radioControl, index) in radioControls"
      :key="index"
      v-model="model"
      v-bind="{ ...radioControl, error: error }"
      class="radioButtonController__radioButton"
      @update:model-value="handleUpdate"
    />
  </div>
</template>

<style lang="scss" scoped>
.radioButtonController {
  display: flex;
  gap: 1.6rem;
  $root: &;

  &--horizontal {
    flex: 1;
    flex-direction: row;
    justify-content: space-between;

    #{$root}__radioButton {
      max-width: 24rem;
    }
  }

  &--vertical {
    flex-direction: column;
  }
}

@include atM {
  .stepOne, .stepTwo, .stepThree {
    .radioButtonController {
      &--horizontal {
        justify-content: flex-start;
      }
    }
  }
}
</style>
